<template>
  <g>
    <rect class="process-item" :fill="getStatusColor()" width="150" height="60" rx=10 ry=10>
    </rect>
    <text transform="translate(75,35)" text-anchor="middle" text-align="center"
     fill="white">{{processInfo.name}}</text>
  </g>
</template>
<script>
export default {
  name: 'process-item',
  props: {
    processInfo: {
      type: Object,
      default() {
        return {
          status: 0, // 0 未到达 1 到达 2 已完成
          name: '进程名称',
        };
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    getStatusColor() {
      let statusColor = '';
      switch (this.processInfo.status) {
        case 0:
          statusColor = 'rgb(153, 153, 153)';
          break;
        case 1:
          statusColor = '#5bc0de';
          break;
        case 2:
          statusColor = 'rgb(92, 184, 92)';
          break;
        default:
          break;
      }
      return statusColor;
    },
  },
};
</script>
